import { useEffect, useState } from "react";
import { ArrowRight } from "lucide-react";
import { useSite } from "../../context/SiteContext";

const MobileCTA = () => {
  const { openBooking, bookingOpen } = useSite();
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.scrollY > 480);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div
      data-testid="mobile-sticky-cta"
      className={`fixed bottom-0 inset-x-0 z-40 md:hidden transition-[transform,opacity] duration-300 ${
        show && !bookingOpen ? "translate-y-0 opacity-100" : "translate-y-full opacity-0 pointer-events-none"
      }`}
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <div className="glass border-t border-slate-200/60 dark:border-white/10 px-4 py-3">
        <button
          data-testid="mobile-sticky-cta-button"
          onClick={openBooking}
          className="w-full inline-flex items-center justify-center gap-2 rounded-full bg-brand-navy dark:bg-brand-sky text-white dark:text-brand-ink font-bold px-6 py-3.5 text-sm shadow-[0_10px_30px_-10px_rgba(42,49,146,0.5)]"
        >
          Book a Discovery Call
          <ArrowRight size={15} />
        </button>
      </div>
    </div>
  );
};
export default MobileCTA;
